import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { StartAPetitionPagePageData } from './api.graphql';
import type { StartAPetitionPagePageDataQuery, StartAPetitionPagePageDataQueryVariables } from './api.graphql';

export type StartAPetitionPageData = StartAPetitionPagePageDataQuery;

export type StartAPetitionPageFeatureConfigs = StartAPetitionPageData['featureConfigs'];

export async function getStartAPetitionPageData({ gql: { fetch } }: UtilityContext): Promise<StartAPetitionPageData> {
	const { data } = await fetch<StartAPetitionPagePageDataQuery, StartAPetitionPagePageDataQueryVariables>({
		query: StartAPetitionPagePageData,
		rejectOnError: true,
	});

	return data;
}
